module.exports = __webpack_public_path__ + "static/media/sports2.9fb7c9f4.jpg";